import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-procedure-summary',
  templateUrl: './procedure-summary.component.html',
  styleUrls: ['./procedure-summary.component.scss']
})
export class ProcedureSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
